import {RouteRecordRaw} from "vue-router";

import LoginView from "@/views/LoginView.vue";
import HomeView from "@/views/HomeView.vue";
import MyProfileView from "@/views/MyProfileView.vue";
import EditRepeatsView from "@/views/EditRepeatsView.vue";
import SponsorsView from "@/views/SponsorsView.vue";
import InviteSponsorView from "@/views/InviteSponsorView.vue";
import InvitePreviousSponsorsView from "@/views/InvitePreviousSponsorsView.vue";
import AboutKKView from "@/views/AboutKKView.vue";
import AddSponsorView from "@/views/AddSponsorView.vue";
import ChooseEventView from "@/views/ChooseEventView.vue";
import ChooseOrganizationView from "@/views/ChooseOrganizationView.vue";
import StartView from "@/views/StartView.vue";

import StatisticsView from "@/views/StatisticsView.vue";
import UserStatisticsView from "@/views/UserStatisticsView.vue";
import EventStatisticsView from "@/views/EventStatisticsView.vue";
import AllStatisticsView from "@/views/AllStatisticsView.vue";
import TopEventParticipants from "@/views/TopEventParticipantsView.vue";

import PermissionView from "@/views/PermissionView.vue";
import InstructionsView from "@/views/InstructionsView.vue";
import MobileAppInstructionsView from "@/views/MobileAppInstructionsView.vue";
import PrivacySettingsView from "@/views/PrivacySettingsView.vue";

export const routes: RouteRecordRaw[] = [
    {name: "LoginView", path: "/login", component: LoginView},
    {name: "Start", path: "/start", component: StartView},
    {name: "HomeView", path: "/", component: HomeView},
    {name: "MyProfileView", path: "/myprofile", component: MyProfileView},
    {name: "PrivacySettings", path: "/privacy-settings", component: PrivacySettingsView},
    {name: "SponsorsView", path: "/sponsors", component: SponsorsView},
    {name: "InviteSponsorView", path: "/invite-sponsor", component: InviteSponsorView},
    {name: "InvitePreviousSponsors", path: "/invite-previous-sponsors", component: InvitePreviousSponsorsView},
    {name: "AboutKK", path: "/about", component: AboutKKView},
    {name: "AddSponsorView", path: "/add-sponsor", component: AddSponsorView},
    {name: "ChooseEventView", path: "/choose-event", component: ChooseEventView},
    {name: "ChooseOrganizationView", path: "/choose-organization", component: ChooseOrganizationView},
    {
        name: "StatisticsView",
        path: "/statistics",
        component: StatisticsView,
        children: [
            {path: 'user', component: UserStatisticsView},
            {path: 'event', component: EventStatisticsView},
            {path: 'participants', component: TopEventParticipants},
            {path: 'all', component: AllStatisticsView},
        ],
    },
    {name: "EditLapsView", path: "/edit-laps", component: EditRepeatsView},
    {name: "PermissionView", path: "/permission", component: PermissionView},
    {name: "InstructionsView", path: "/instructions", component: InstructionsView},
    {name: "MobileAppInstructionsView", path: "/mobile-app-instructions", component: MobileAppInstructionsView},

    // Redirect unknown routes to home view
    {path: "/:catchAll(.*)", redirect: "/"},
];

export default routes;
